import React, { FC } from 'react'

import { PageLayout } from 'Components'

const NutritionAnalysisLayout: FC = ({ children }) => (
  <PageLayout variant="smallcircle">
    <div className="container">{children}</div>
  </PageLayout>
)

export default NutritionAnalysisLayout
